/* KERACELL mobile header: the KERACELL masthead collapses into a compact sticky state once the page scrolls (all widths since the 16 Sept desktop mirror). */
(function () {
  var h = document.getElementById('kc-header');
  if (!h) return;
  var mq = window.matchMedia('(min-width:0px)'); /* 16 Sept: desktop mirrors mobile, so the compact state applies at every width */
  var ticking = false;
  function update() {
    ticking = false;
    if (!mq.matches) { h.classList.remove('is-compact'); return; }
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if (y > 32 && !h.classList.contains('is-compact')) h.classList.add('is-compact');
    else if (y <= 8 && h.classList.contains('is-compact')) h.classList.remove('is-compact');
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', update); else if (mq.addListener) mq.addListener(update);
  update();
})();
